import { Stack } from "@mui/material";
import BankTable from "./table";

const Bank = () => {
  return (
    <Stack>
      <BankTable />
    </Stack>
  );
};

export default Bank;
